import { Box } from "@mui/material";
import React from "react";

const Footer = () => {
  return (
    <Box
      sx={{
        marginTop: "5rem",
        width: "100%",
        height: "100px",
        backgroundColor: "#02373A",
      }}
    ></Box>
  );
};

export default Footer;
